import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"right":true,"top":true,"light":""},model:{value:(_vm.showNotifier),callback:function ($$v) {_vm.showNotifier=$$v},expression:"showNotifier"}},[_c(VLayout,{attrs:{"wrap":""}},[_c(VFlex,{attrs:{"xs11":"","align-self-center":""}},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c(VFlex,{attrs:{"xs1":""}},[_c(VBtn,{attrs:{"icon":"","small":""},on:{"click":_vm.hide}},[_c(VIcon,{staticStyle:{"font-size":"16px"}},[_vm._v(" mdi-close ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }